import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useLocation, useNavigate } from "react-router-dom";
import {
  BottomNavigation,
  BottomNavigationAction,
  Box,
  Stack,
} from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import SmsIcon from "@mui/icons-material/Sms";
import CalendarViewDayIcon from "@mui/icons-material/CalendarViewDay";
import getLPTheme from "../getLPTheme";

const App = ({ withNavigation, children, top }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const lightTheme = createTheme(getLPTheme("light"));

  return (
    // renstart
    <ThemeProvider theme={lightTheme}>
      <Stack
        className="App"
        sx={{
          justifyContent: "space-between",
        }}
      >
        <Box>{top}</Box>
        <Box sx={{ overflowY: "auto", height: "100%" }}>{children}</Box>
        <Box>
          {withNavigation ? (
            <BottomNavigation
              showLabels
              value={""}
              sx={{
                width: "100%",
                // position: 'fixed',
                // bottom: 0,
                m: 0,
                p: 0,
                display: { xs: "flex" },
                borderTop: "1px solid #e3e3e3",
                zIndex: 1299, // greate than swipable drawer 1300
              }}
              onChange={(event, newValue) => {
                if (newValue == "account") {
                  navigate("/account");
                } else if (newValue == "services") {
                  navigate("/");
                } else if (newValue == "chats") {
                  navigate("/chats");
                }
                //                 navigate('/login');
                //             } else if (/\/users\/\d+\/enable/.test(pathname)) {
              }}
            >
              <BottomNavigationAction
                sx={{
                  color: pathname == "/" ? "#76c6ff" : null,
                  "&.Mui-selected": {
                    color: "crimson",
                  },
                }}
                label="Приемы"
                value={"services"}
                icon={<CalendarViewDayIcon />}
              />
              <BottomNavigationAction
                sx={{
                  color: pathname == "/chats" ? "#76c6ff" : null,
                  "&.Mui-selected": {
                    color: "crimson",
                  },
                }}
                label="Чаты"
                value={"chats"}
                icon={<SmsIcon />}
              />
              <BottomNavigationAction
                sx={{
                  color: pathname == "/account" ? "#76c6ff" : null,
                  "&.Mui-selected": {
                    color: "crimson",
                  },
                }}
                label="Aккаунт"
                value={"account"}
                icon={<AccountCircleIcon />}
              />
            </BottomNavigation>
          ) : null}
        </Box>
      </Stack>
    </ThemeProvider>
  );
};

export default App;
